module.exports = __webpack_public_path__ + "static/media/signal-alt.585ef291.svg";